export default __webpack_public_path__ + "media/images/icons/icon-burger-menu-fc9b1830b18c0732230cc00674548d6c.svg";